import DividerMui5 from '@mui/material/Divider';
import Alert from '@mui/material/Alert';
import { styled as styledMui5 } from '@mui/material/styles';

export const AuctionSectionMui5 = styledMui5('div')(
  ({ theme }) => `
  padding: ${theme.spacing(2, 3)};
  border-bottom: 1px solid ${theme.palette.divider};
  &:last-of-type {
    border-bottom: 0;
    margin-bottom: ${theme.spacing(2)};
  }`,
);

export const FormRowMui5 = styledMui5('div')(
  ({ theme }) => `
  display: flex;
  align-items: center;
  margin: ${theme.spacing(1, 0)};`,
);

export const FormRowLabelFixedMui5 = styledMui5('div')(
  ({ theme }) => `
  min-width: 204px;
  max-width: 204px;
  padding-right: ${theme.spacing(2)};`,
);

export const FormRowValueMui5 = styledMui5('div')`
  flex: 1
`;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - my IDE cannot figure out types for styled delegate (it thinks it's a MUI-4 delegate)
export const FormGroupTitleMui5 = styledMui5('h6')(({ theme }) => ({
  ...theme.typography.overline,
  position: 'relative',
  textAlign: 'center',
  overflow: 'hidden',
  margin: theme.spacing(1, -2),
  '&::before, &::after': {
    position: 'absolute',
    content: '""',
    overflow: 'hidden',
    top: '50%',
    width: '50%',
    height: 1,
    background: theme.palette.divider,
  },
  '&::before': {
    marginLeft: '-51%',
    textAlign: 'right',
  },
  '&::after': {
    marginLeft: '1%',
    textAlign: 'right',
  },
}));

export const FormDividerMui5 = styledMui5(DividerMui5)(
  ({ theme }) => `
  &.MuiDivider-root {
    margin: ${theme.spacing(2, -2, 3)};
  }`,
);

export const FormAlert = styledMui5(Alert)(
  ({ theme }) => `
  &.MuiAlert-root {
    margin: ${theme.spacing(0, 0, 2)};
    padding: ${theme.spacing(2)};
  }`,
);

export const HeaderWrapperMui5 = styledMui5('div')`
  display: flex;
  flex-wrap: wrap;
`;

export const HeaderItemMui5 = styledMui5('div')(
  ({ theme }) => `
  padding: ${theme.spacing(1, 1.5)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;`,
);

export const HeaderItemLinkMui5 = styledMui5('a')(
  ({ theme }) => `
  padding: ${theme.spacing(1, 1.5)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-decoration: none;
  &:hover {
    background-color: ${theme.palette.grey[100]};
  }`,
);

export const BoldMoneyMui5 = styledMui5('b')(
  ({ theme }) => `
  color: ${theme.palette.grey[900]};`,
);

export const PrimaryBoldMoneyMui5 = styledMui5(BoldMoneyMui5)(
  ({ theme }) => `
  color: ${theme.palette.primary.main};`,
);
